import { forwardRef, memo } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

import { cx } from '@/utils/cx';

import styles from './HeaderTop.module.scss';

import type { VisibleOn } from '../types';

export interface HeaderTopProps extends ComponentPropsWithoutRef<'div'> {
  /** 특정 디바이스에서만 노출. 미지정 = 항상 노출 */
  visibleOn?: VisibleOn;
}

export const HeaderTop = memo(
  forwardRef<HTMLDivElement, HeaderTopProps>(({ children, className, visibleOn, ...rest }, ref) => {
    return (
      <div
        className={cx(styles.top, className)}
        data-core-ui-header-slot="top"
        data-core-ui-visible-on={visibleOn}
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    );
  }),
);

HeaderTop.displayName = 'Header.Top';
